import React from 'react';
import { Card, CardActions } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import moment from 'moment';

import { Button } from 'react-toolbox/lib/button';

import Spinner from '~/components/Spinner';
import { list, remove } from '~/actions/dashboards';

import Styles from './style.scss';

class DashboardConfig extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    router: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
  }

  navigate(url) {
    return this.context.router.history.push(url);
  }

  editItem(id) {
    this.navigate(`/dashboardconfig/${id}`);
  }

  removeItem(id) {
    remove(this.props.dispatch, this.context.apiClient, id);
  }

  render() {
    const dashboards = (this.props.list && this.props.list.toJS()) || false;
    if (!dashboards) {
      return (
        <div className={Styles.content}>
          <Spinner />
        </div>
      );
    }

    const dashboardItems = dashboards.map(item => {
      const type = item.info ? 'Init' : 'Need init';
      return (
        <Card className={Styles.dashboardBox} key={item.dashboardId}>
          <div className={Styles.dashboardName}>
            Name: {item.info && item.info.name}
          </div>
          Location: {item.info && item.info.location}
          <br />
          ID: {item.shortId}
          <br />
          Created: {moment(item.createDate).format('LLL')}
          <br />
          Type: {type}
          <CardActions>
            <Button
              label="Edit"
              primary
              onClick={() => {
                this.editItem(item.dashboardId);
              }}
            />
            <Button
              label="Remove"
              primary
              onClick={() =>
                this.context.dialogPush('message', {
                  content: 'Are you sure?',
                  onConfirm: () => this.removeItem(item.dashboardId)
                })
              }
            />
          </CardActions>
        </Card>
      );
    });
    return (
      <div className={Styles.content}>
        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.title}>Dashboard configurator</div>
            <div style={{ position: 'relative' }}>{dashboardItems}</div>
            <br />
            <br />
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.getIn(['dashboards', 'list'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  DashboardConfig
);



// WEBPACK FOOTER //
// ./app/pages/DashboardConfig/index.js